import * as React from "react";
import styled, { css } from "styled-components";
import { ReadOnlyFormGroup } from "components/common";
import { Well } from "components/bootstrap";
import usePluggableLicenseCheck from "hooks/usePluggableLicenseCheck";
const NewExampleWell = styled(Well)(
  ({ theme }) => css`
    margin-bottom: 5px;
    font-family: ${theme.fonts.family.monospace};
    font-size: ${theme.fonts.size.body};
    white-space: pre-wrap;
    overflow-wrap: break-word;
  `
);
const SlackNotificationDetails = ({ notification }) => {
  var _a, _b;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Webhook URL", value: notification.config.webhook_url }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Channel", value: notification.config.channel }), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: "Custom Message Template ",
      value: /* @__PURE__ */ React.createElement(NewExampleWell, { bsSize: "small" }, notification.config.custom_message || /* @__PURE__ */ React.createElement("em", null, "Empty body"))
    }
  ), ((_b = (_a = usePluggableLicenseCheck("/license/security")) == null ? void 0 : _a.data) == null ? void 0 : _b.valid) && /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: "Include Event Procedure in Email Body",
      value: notification.config.include_event_procedure
    }
  ), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Message Backlog Limit", value: notification.config.backlog_size }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "User Name", value: notification.config.user_name }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Include Title", value: notification.config.include_title }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Notify Channel", value: notification.config.notify_channel }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Link Names", value: notification.config.link_names }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Icon URL", value: notification.config.icon_url }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Icon Emoji", value: notification.config.icon_emoji }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Time Zone", value: notification.config.time_zone }));
};
export default SlackNotificationDetails;
